import React from 'react';

import { IComponentBaseProps } from '../models/IComponentBaseProps.js';
// Maybe handle the loading here or another HOC
export const withSelector = <P extends IComponentBaseProps>(
	// eslint-disable-next-line @typescript-eslint/naming-convention
	WrappedComponent: React.ElementType<P>,
	propsOrSelector: string | any,
	className = '',
) => {
	class withSelector extends React.Component<P, any> {
		render() {
			const props = this.props;
			let selector = propsOrSelector;
			if (typeof propsOrSelector === 'object') {
				selector = propsOrSelector.selector || propsOrSelector['data-selector'];
			}
			if (props.hide) {
				return null;
			}
	
			const elementClassName = `${className}${props.className ? ` ${props.className}` : ''}`;
	
			if (typeof WrappedComponent === 'string') {
				return getTagComponent({ tag: WrappedComponent, ...props, className: elementClassName });
			}
	
			return <WrappedComponent data-selector={selector} {...props} className={elementClassName} />;
		}
	}
	return withSelector;
};

interface ITagComponentProps {
	tag: keyof JSX.IntrinsicElements;
}

const getTagComponent: React.FunctionComponent<ITagComponentProps & React.HTMLAttributes<HTMLOrSVGElement>> = ({
	// eslint-disable-next-line @typescript-eslint/naming-convention
	tag: Wrapper = 'div',
	children,
	...rest
}) => {
	return <Wrapper {...rest}>{children}</Wrapper>;
};
